// const bootConfig = require("./bootConfig.js");
let bootConfig = null;

if (window.location.hostname.indexOf('stage')!==-1) {
  bootConfig = {
    supply:'https://sweb.stage.yunshanmeicai.com/',
    supplyGuide:'https://scm-node.stage.yunshanmeicai.com/static/supplierPoolGuide.html'

  };
} else if(window.location.hostname.indexOf('test') !==-1 || window.location.hostname.indexOf('localhost') !==-1 ){
  bootConfig = {
    supply:'https://sweb.stage.yunshanmeicai.com/',
    supplyGuide:'https://scm-node.stage.yunshanmeicai.com/static/supplierPoolGuide.html'

  };
}else {
  bootConfig = {
    supply:'https://sweb.yunshanmeicai.com/',
    supplyGuide:'https://scm-node.yunshanmeicai.com/static/supplierPoolGuide.html'
  };
}

module.exports = bootConfig;
